/** Schedule work during idle time; falls back to setTimeout(0) when requestIdleCallback is missing. */
export function scheduleIdleTask(task: () => void, options?: { timeout?: number }): number {
  const timeout = options?.timeout ?? 1500;
  if (typeof requestIdleCallback !== 'undefined') {
    return requestIdleCallback(task, { timeout });
  }
  return window.setTimeout(task, 0) as unknown as number;
}

export function cancelIdleTask(handle: number | null): void {
  if (handle == null) return;
  if (typeof cancelIdleCallback !== 'undefined') {
    cancelIdleCallback(handle);
  } else {
    window.clearTimeout(handle);
  }
}
